import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { cleanState } from '@ublend-npm/aula-editor';
import {
  createPermissionDeniedToast,
  isMaterialRbacEnabled,
  canAccessEducatorArea,
} from '../../../../../../core/materials/permissions';
import showToast from '../../../../../../core/toasts/operations/showToast.operation';
import {
  currentClassRoomId,
  getIsStudent,
} from '../../../../../../core/selectors/classroom';
import { getUserPermissionsInCurrentSpace } from '../../../../../../core/utils/permissions';
import * as appCreators from '../../../../../actions/materials';
import { selectors, operations } from '../../../../../store/materials';
import MaterialListEducatorOnly from './MaterialListEducatorOnly';

const selectPieces = createStructuredSelector({
  classRoomId: currentClassRoomId,
  materialEducatorOnlyIds: selectors.topLevelMaterialEducatorOnlyIds,
  isFetchingSections: selectors.isFetchingSections,
  canCreate: canAccessEducatorArea,
  canView: canAccessEducatorArea,
  permissions: getUserPermissionsInCurrentSpace,
  isRbacEnabled: isMaterialRbacEnabled,
});

const mapStateToProps = (state) => {
  const {
    classRoomId,
    materialEducatorOnlyIds,
    isFetchingSections,
    canCreate,
    canView,
    permissions,
    isRbacEnabled,
  } = selectPieces(state);

  // In educator area: if user has educator area permission, they can do everything
  // canCreate is already canAccessEducatorArea, so use it directly
  return {
    classRoomId,
    isFetchingSections,
    materialEducatorOnlyIds,
    canCreate,
    canView,
    permissions,
    isRbacEnabled,
    isReadOnlyUser: !canCreate, // If they can access educator area, they're not read-only
    isStudent: getIsStudent(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onAddClick: () =>
    dispatch(
      operations.createSection({
        content: cleanState,
        educatorOnly: true,
        hidden: false,
        onSelect: appCreators.selectSectionInJourney,
      })
    ),
  onPermissionDenied: (permissionKey) =>
    dispatch(showToast(createPermissionDeniedToast(permissionKey))),
  onCreateFolder: (educatorOnly) =>
    dispatch(operations.createFolder(educatorOnly)),
  onImportMaterial: (params) => dispatch(operations.importMaterial(params)),
  onExportMaterial: (educatorOnly) =>
    dispatch(appCreators.exportMaterial(educatorOnly)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaterialListEducatorOnly);
